module.exports = __webpack_public_path__ + "static/media/ico-portfolio-new.61881136.svg";